import {TranslateService} from '@ngx-translate/core';
import {BaseAsyncValue} from '@ordersnproducts/modules/shared/models/async-value';
import {getDCOLargeOrder} from '@ordersnproducts/modules/shared/reducers';
import {Observable, of} from 'rxjs';
import {filter, map, takeUntil, withLatestFrom} from 'rxjs/operators';
import {getRmsRecipeSpecifications} from '../../selectors';
import {largeOrderMessageConst} from '@ordersnproducts/modules/shared/effects/dco.effect';
import {ExperiencesService} from '@ordersnproducts/modules/shared/services/experiences.service';

export namespace QuantityWarningOpenPlatformProvider {
    export class IsLargeOrderMessageQuantity extends BaseAsyncValue<string> {
      // @ts-ignore
      getValue(): Observable<string> {
        const translate: TranslateService = this.injector.get(TranslateService);
        const largeOrderEnabled = this.injector.get(ExperiencesService).commandLargeOrderEnabled();
        if (largeOrderEnabled) {
          return this.store.select(getRmsRecipeSpecifications).pipe(
            withLatestFrom(this.store.select(getDCOLargeOrder)),
            filter(([formRecipe, {largeOrder, largeOrderQuantity}]) => !!largeOrder && !!largeOrder.isBigOrder && !!formRecipe.length),
            map(([formRecipe, { largeOrder, largeOrderQuantity }]) => {
              const quantity = this.form.value.quantity;
              if (!!largeOrder && largeOrder.message === largeOrderMessageConst && quantity >= largeOrderQuantity) {
                return translate.instant('views.specifications.large_order_quantity', {
                  largeOrderQuantity,
                });
              }
              return '';
            }),
            takeUntil(this.ngDestroy),
          );
        } else {
          return of(null);
        }
      }
  }
}
